<ui-skeleton
  [uiActive]="true"
  [uiTitle]="{ width: '80%', height: 'sm' }"
  [uiAvatar]="{ size: 'default', shape: 'circle' }"
  [uiParagraph]="{ rows: 3, width: '100%' }"
  [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-sm' }"></ui-skeleton>
